import React from 'react';
import { Button, ButtonFill, Dialog, DialogContent, DialogFooter, DialogWidth } from '@tcc/fds';
import { getMessage } from '@tcc/i18n';

interface ExpertoDialogProps {
  isOpen?: boolean;
  onClose?: () => void;
  onOpenChange?: (open: boolean) => void;
  onPrimaryAction?: () => void;
}

export const ExpertoDialog = ({
  isOpen = false,
  onClose,
  onOpenChange,
  onPrimaryAction,
}: ExpertoDialogProps) => (
  <Dialog
    testId="experto-dialog"
    headerProps={{ title: getMessage('experto.dialog.title') }}
    isModal
    width={DialogWidth.Regular}
    open={isOpen}
    onOpenChange={onOpenChange}
  >
    <DialogContent>
      {getMessage('experto.dialog.content')}
    </DialogContent>
    <DialogFooter>
      <Button onClick={onClose} fill={ButtonFill.Ghost} testId="experto-dialog-dismiss-button">
        {getMessage('experto.dialog.continue')}
      </Button>
      <Button onClick={onPrimaryAction} testId="experto-dialog-primary-button">
        {getMessage('fds.cancel')}
      </Button>
    </DialogFooter>
  </Dialog>
);
